import { FDRStatus, UserId } from '@cibo/core'
import {
  AuthUserPermission,
  PaginatedUsersTable,
  useFDRAcresColumn,
  useFDRFieldCountColumn,
  useOrgUserColumns,
  usePermissions,
} from '@cibo/profile'
import { Stack } from '@mui/material'
import { ADMIN_ROUTES } from 'navigation/types'
import { useMemo } from 'react'
import { generatePath, useNavigate, useParams } from 'react-router-dom'

export const OrganizationUsers = () => {
  const { organizationId = '' } = useParams()
  const navigate = useNavigate()
  const { can } = usePermissions()
  const availableColumns = useOrgUserColumns({})
  const enrolledAcresColumn = useFDRAcresColumn(FDRStatus.enrolled, { sortable: false })
  const enrolledFieldCountColumn = useFDRFieldCountColumn(FDRStatus.enrolled, { sortable: false })
  const columns = useMemo(
    () => [
      availableColumns.name,
      availableColumns.email,
      enrolledFieldCountColumn,
      enrolledAcresColumn,
      availableColumns.totalFields,
      availableColumns.lastLoginDate,
    ],
    [availableColumns]
  )
  return (
    <Stack spacing={2}>
      <PaginatedUsersTable
        availableFilters={{
          includeInactive: false,
          persona: true,
          organization: false,
          state: false,
          county: false,
          acres: true,
        }}
        columns={columns}
        baseQuery={{
          orgId: organizationId,
          fdrStats: [{ status: FDRStatus.enrolled }, { status: FDRStatus.isEngaged }],
        }}
        headerPaletteColor="primary"
        goToUser={({ userId }: { userId: UserId }) => {
          if (can({ useAny: AuthUserPermission.USER_DASHBOARD })) {
            navigate(
              generatePath(ADMIN_ROUTES.ORGANIZATION_DETAIL_USER_DETAIL, {
                organizationId,
                userId: userId.toString(),
              })
            )
          }
        }}
      />
    </Stack>
  )
}
